import { useState, useCallback } from 'react';

// Service
import OrderService from '../../services/orderService';

//Hooks
import useUser from '../user/useUser';

const useCard = ( orderId ) => {
    const { branch } = useUser();
    const [loading, setLoading] = useState(false);

    const searchCardPlans = useCallback((bankId, cardId, binNumber) => {
        setLoading(true);
        return OrderService
            .GetCardPlans(orderId, bankId, cardId, branch?.id)
            .then(card => {
                card.bin = binNumber;
                card.bankId = bankId;
                card.cardId = cardId;
                return card;
            })
            .finally(() => setLoading(false))
    }, [orderId, branch?.id])

    const searchCardPlansWithAnAmount = useCallback((bankId, cardId, binNumber, amount) => {
        setLoading(true);
        return OrderService
            .GetCardPlansWithAmount(orderId, bankId, cardId, amount, branch?.id)
            .then(card => {
                card.bin = binNumber;
                card.bankId = bankId;
                card.cardId = cardId;
                return card;
            }) 
            .finally(() => setLoading(false))
    }, [orderId, branch?.id])

    const searchCard = useCallback((binNumber) => {
        setLoading(true);
        return OrderService
            .GetCard(orderId, binNumber, branch?.id, false)
            .then(card => {
                card.bin = binNumber;
                return card;
            })
            .finally(() => setLoading(false))
    }, [orderId, branch?.id])

    const searchCardWithAnAmount = useCallback((binNumber, amount) => {
        setLoading(true);
        return OrderService
            .GetCardWithAmount(orderId, amount, binNumber, branch?.id)
            .then(card => {
                card.bin = binNumber;
                return card;
            }) 
            .finally(() => setLoading(false))
    }, [orderId, branch?.id])
    
    return {
        searchCard,
        searchCardPlans,
        searchCardWithAnAmount,
        searchCardPlansWithAnAmount,
        loading
    };
}

export default useCard;